import { Cloud, CheckCircle2 } from "lucide-react";
import { SectionHeading, Reveal } from "./Reveal";
import { CLOUD_ITEMS, CLOUD_CAPABILITIES } from "../data/content";

const CloudViz = () => (
  <svg viewBox="0 0 100 100" className="h-full w-full text-foreground" aria-hidden="true" data-testid="cloud-viz">
    {CLOUD_CAPABILITIES.map((_, i) => {
      const a = (i / CLOUD_CAPABILITIES.length) * Math.PI * 2 - Math.PI / 2;
      const x = 50 + 36 * Math.cos(a);
      const y = 50 + 36 * Math.sin(a);
      return (
        <g key={i}>
          <line x1="50" y1="50" x2={x} y2={y} stroke="#8BC34A" strokeOpacity="0.45" strokeWidth="0.4" className="animate-dash" style={{ animationDelay: `${i * 0.2}s` }} />
          <circle r="1.1" fill="#c9f29b" className="travel-pulse">
            <animateMotion dur={`${2.6 + i * 0.35}s`} repeatCount="indefinite" path={`M 50 50 L ${x} ${y} L 50 50`} />
          </circle>
          <circle cx={x} cy={y} r="2.4" fill="#8BC34A" className="animate-pulse-soft" style={{ animationDelay: `${i * 0.35}s` }} />
        </g>
      );
    })}
    <circle cx="50" cy="50" r="13" fill="none" stroke="#8BC34A" strokeOpacity="0.7" strokeWidth="0.5" />
    <circle cx="50" cy="50" r="8" fill="#8BC34A" fillOpacity="0.12" />
  </svg>
);

export const CloudDevOps = () => (
  <section id="cloud" className="relative py-24 sm:py-32" data-testid="cloud-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
        <div>
          <SectionHeading
            index="07"
            eyebrow="Cloud & DevOps"
            title="Built for production. Ready to scale."
            sub="Cloud-native applications designed, deployed and operated with the discipline production systems demand."
          />
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="cloud-items">
              {CLOUD_ITEMS.map((item) => (
                <span
                  key={item}
                  className="rounded-full border hairline bg-card/60 px-4 py-2 text-sm font-medium text-foreground/80 transition-colors duration-200 hover:border-primary/50 hover:text-primary"
                >
                  {item}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {CLOUD_CAPABILITIES.map((cap) => (
                <li key={cap} className="flex items-center gap-2.5 text-sm text-muted-foreground">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" />
                  {cap}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="relative mx-auto aspect-square max-w-md overflow-hidden rounded-2xl border hairline bg-card/40">
            <div className="absolute inset-0 grid-texture opacity-60" aria-hidden="true" />
            <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 text-primary">
              <Cloud className="h-10 w-10" />
            </div>
            <CloudViz />
            <div className="pointer-events-none absolute inset-0">
              {CLOUD_CAPABILITIES.map((cap, i) => {
                const a = (i / CLOUD_CAPABILITIES.length) * Math.PI * 2 - Math.PI / 2;
                const x = 50 + 36 * Math.cos(a);
                const y = 50 + 36 * Math.sin(a);
                return (
                  <span
                    key={cap}
                    className="absolute -translate-x-1/2 translate-y-3 whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground"
                    style={{ left: `${x}%`, top: `${y}%` }}
                  >
                    {cap}
                  </span>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
